import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createFamilyFestPickupAssignmentAsync, updateFamilyFestPickupAssignmentAsync, getAllFamilyFestPickupAssignmentsAsync, getAssignedFamilyFestAttendeesByPickupLocationIdAsync, getUnassignedFamilyFestAttendeesByPickupLocationIdAsync, getFamilyFestAttendeesByPickupLocationIdAsync, getFamilyFestPickupAssignmentByIdAsync, deleteFamilyFestPickupAssignmentAsync, unassignFamilyFestAttendeeFromVehicleAsync, assignFamilyFestAttendeeToVehicleAsync, getFamilyFestAttendeesByVehicleIdAsync, getUnassignedFamilyFestAttendeesByEventIdAsync, getAssignedFamilyFestAttendeesByEventIdAsync, reassignFamilyFestAttendeesToPickupLocationAsync, updateFamilyFestVehicleAttendeeCountAsync, autoAssignFamilyFestAttendeesToPickupLocationAsync } from './familyFestPickupAssignmentThunk';
const initialState = {
    status: APIStatus.IDLE,
    assignment: undefined,
    assignments: null,
    assignedAttendees: null,
    unassignedAttendees: null,
    attendees: null,
    vehicleAttendees: null
};
export const familyFestPickupAssignmentSlice = createSlice({
    name: 'familyFestPickupAssignment',
    initialState,
    reducers: {
        resetFamilyFestAttendees: (state) => {
            state.assignedAttendees = undefined;
            state.unassignedAttendees = undefined;
            state.attendees = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createFamilyFestPickupAssignmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createFamilyFestPickupAssignmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignment = action.payload;
        })
            .addCase(createFamilyFestPickupAssignmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateFamilyFestPickupAssignmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateFamilyFestPickupAssignmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignment = action.payload;
        })
            .addCase(updateFamilyFestPickupAssignmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllFamilyFestPickupAssignmentsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllFamilyFestPickupAssignmentsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignments = action.payload;
        })
            .addCase(getAllFamilyFestPickupAssignmentsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAssignedFamilyFestAttendeesByPickupLocationIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAssignedFamilyFestAttendeesByPickupLocationIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignedAttendees = action.payload;
        })
            .addCase(getAssignedFamilyFestAttendeesByPickupLocationIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getUnassignedFamilyFestAttendeesByPickupLocationIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getUnassignedFamilyFestAttendeesByPickupLocationIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.unassignedAttendees = action.payload;
        })
            .addCase(getUnassignedFamilyFestAttendeesByPickupLocationIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFamilyFestAttendeesByPickupLocationIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFamilyFestAttendeesByPickupLocationIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.attendees = action.payload;
        })
            .addCase(getFamilyFestAttendeesByPickupLocationIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFamilyFestPickupAssignmentByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFamilyFestPickupAssignmentByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignment = action.payload;
        })
            .addCase(getFamilyFestPickupAssignmentByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteFamilyFestPickupAssignmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteFamilyFestPickupAssignmentAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deleteFamilyFestPickupAssignmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(unassignFamilyFestAttendeeFromVehicleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(unassignFamilyFestAttendeeFromVehicleAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignment = action.payload.data;
        })
            .addCase(unassignFamilyFestAttendeeFromVehicleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(assignFamilyFestAttendeeToVehicleAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(assignFamilyFestAttendeeToVehicleAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignment = action.payload.data;
        })
            .addCase(assignFamilyFestAttendeeToVehicleAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFamilyFestAttendeesByVehicleIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFamilyFestAttendeesByVehicleIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.vehicleAttendees = action.payload;
        })
            .addCase(getFamilyFestAttendeesByVehicleIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getUnassignedFamilyFestAttendeesByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getUnassignedFamilyFestAttendeesByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.unassignedAttendees = action.payload;
        })
            .addCase(getUnassignedFamilyFestAttendeesByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAssignedFamilyFestAttendeesByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAssignedFamilyFestAttendeesByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignedAttendees = action.payload;
        })
            .addCase(getAssignedFamilyFestAttendeesByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(reassignFamilyFestAttendeesToPickupLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(reassignFamilyFestAttendeesToPickupLocationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(reassignFamilyFestAttendeesToPickupLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateFamilyFestVehicleAttendeeCountAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateFamilyFestVehicleAttendeeCountAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.assignment = action.payload.data;
        })
            .addCase(updateFamilyFestVehicleAttendeeCountAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(autoAssignFamilyFestAttendeesToPickupLocationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(autoAssignFamilyFestAttendeesToPickupLocationAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(autoAssignFamilyFestAttendeesToPickupLocationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetFamilyFestAttendees } = familyFestPickupAssignmentSlice.actions;
export default familyFestPickupAssignmentSlice.reducer;
